import { Typography } from 'app/components/ui';
import React from 'react';
import { i18n } from 'app/utils/i18n';

interface CustomToggleProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  iconOnly?: boolean;
}

export const CustomToggle = React.forwardRef<HTMLButtonElement, CustomToggleProps>(({ onClick, iconOnly = false }, ref) => (
  <button
    ref={ref}
    className={`filter-dropdown__toggle ${iconOnly ? 'filter-dropdown__toggle--icon-only' : ''}`}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      onClick(e);
    }}
  >
    <i className="fa fa-filter" />

    {!iconOnly && (
      <>
        <Typography variant="body-7">{i18n('tag.filter.label')}</Typography>
        <i className="fa fa-chevron-down" />
      </>
    )}
  </button>
));
